import style from './UserInfo.module.scss';
import { selectLoggedInProviderName, useAppSelector } from '@ax/redux-store';

export interface UserInfoProps {}

const UserInfo = () => {
  const name = useAppSelector(selectLoggedInProviderName);

  return (
    <div className={style.container}>
      <div className={style.title}>{name}</div>
    </div>
  );
};

export default UserInfo;
